
export const WhoIsThisFor = () => {
  return (
    <section>
      <h2 className="text-[62px] font-medium mb-8">Who This Is For</h2>
      <div className="space-y-8 text-[22px] font-inter">
        <div>
          <p className="font-medium mb-4">Senior product leaders and founders who:</p>
          <ul className="list-disc pl-6 space-y-4">
            <li>Need a confidential space to pressure-test strategies before key presentations</li>
            <li>Want to make better decisions balancing user needs with business goals</li>
            <li>Are navigating complex organizational or product challenges</li>
            <li>Seek to strengthen their strategic thinking and leadership capabilities</li>
          </ul>
        </div>
        
        <div>
          <p className="font-medium mb-4">Not a Fit If You Need:</p>
          <ul className="list-disc pl-6 space-y-4">
            <li>Strategy documentation or presentation creation</li>
            <li>Project management support</li>
            <li>Basic product development guidance</li>
          </ul>
        </div>
      </div>
    </section>
  );
};
